/**
 * Math Tooltips for KaTeX
 * 
 * Adds interactive tooltips to parts of KaTeX-rendered math equations.
 * Use \htmlClass{tip-classname}{content} in your LaTeX to mark elements for tooltips.
 * 
 * Usage in LaTeX:
 *   $$\frac{\htmlClass{tip-numerator}{1}}{\htmlClass{tip-denominator}{2}}$$
 */

// Map of tooltip class names to their tooltip text
// Add new tooltips here - the class name maps to the tooltip content
const TOOLTIPS = {
  'tip-numerator': 'Lugeja - arv murrujoone kohal',
  'tip-denominator': 'Nimetaja - arv murrujoone all',
  'tip-fraction': 'Murd - üks arv jagatud teisega',
  'tip-equals': 'Võrdub - näitab, et kaks poolt on samaväärsed',
  'tip-plus': 'Liitmine',
  'tip-minus': 'Lahutamine',
  'tip-times': 'Korrutamine',
  'tip-divide': 'Jagamine'
}

/**
 * Apply tooltips to all elements with registered tooltip classes.
 * Should be called after KaTeX has finished rendering.
 *
 * KaTeX wraps content in an outer .enclosing span that includes margin spacing.
 * We apply the tooltip to the first child element instead, so the tooltip
 * only triggers on the actual math content, not the surrounding whitespace.
 */
export function applyMathTooltips() {
  Object.keys(TOOLTIPS).forEach((className) => {
    document.querySelectorAll('.' + className).forEach((el) => {
      // Find the actual content element (first child that's not whitespace)
      // KaTeX structure: .enclosing.tip-xxx > .mrel/.mord/etc > actual content
      const targetEl = el.firstElementChild || el

      targetEl.classList.add('math-tip')
      targetEl.setAttribute('data-tip', TOOLTIPS[className])
    })
  })
}

/**
 * Register a new tooltip class with its text.
 * @param {string} className - The CSS class name (without the dot)
 * @param {string} tooltipText - The text to display in the tooltip
 */
export function registerTooltip(className, tooltipText) {
  TOOLTIPS[className] = tooltipText
}

/**
 * Initialize math tooltips after KaTeX renders.
 * Waits for DOMContentLoaded and adds a small delay for KaTeX auto-render.
 */
export function initMathTooltips() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      // Delay to ensure KaTeX auto-render has completed
      setTimeout(applyMathTooltips, 150)
    })
  } else {
    // DOM already loaded, just wait for KaTeX
    setTimeout(applyMathTooltips, 150)
  }
}

// Auto-initialize when imported
initMathTooltips()

// Re-apply tooltips after Turbo navigation (if using Turbo)
document.addEventListener('turbo:load', () => {
  setTimeout(applyMathTooltips, 150)
})
